import React, { useState, useEffect } from 'react'
import { MapContainer, TileLayer, Marker, Popup, Circle, LayersControl, LayerGroup } from 'react-leaflet'
import { config } from '../../config'
import styles from '../../css/devices/LocationHistory.module.css'
import 'leaflet/dist/leaflet.css'
import iconMap from '../../components/generals/iconMap'
import MapClickLocation from '../Geofences/mapClickLocation'
import ChangeView from '../Geofences/ChangeView'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function MapaGeofences ({ info, type, setGeofenceData, unitArea }) {
  const [data, setData] = useState(null)

  const { t } = useTranslation('geofences')

  useEffect(() => {
    setData(info)
  }, [info])

  if (data) {
    return (
      <MapContainer
        className="divMaps"
        center={config.map.center}
        zoom={config.map.zoom_specific}
        scrollWheelZoom={true}
      >
        <MapClickLocation setGeofenceData={setGeofenceData} info={info} type={type}/>
        {info.place && (
          <ChangeView
            center={[info.lat, info.lon]}
          />
        )}
        {data && data.place
          ? (
                  <Marker key={data.id} position={[data.lat, data.lon]} icon={iconMap}>
                    <Popup>
                      <div className={styles.popup}>
                        <span>
                          {t('mapGeofences.label')}{data.place}
                        </span>
                      </div>
                    </Popup>
                  </Marker>
            )
          : (
                  <Marker key={data.id} position={[data.lat, data.lon]} icon={iconMap}></Marker>
            )}
            {data && data.area
              ? (
                <Circle
                  center={[data.lat, data.lon]}
                  radius={unitArea && unitArea === 'km' ? data.area * 1000 : data.area}
                  pathOptions={{ color: data.color_range }}
                />
                )
              : (
                <></>
                )}
        <LayersControl position="topright">
          <LayersControl.BaseLayer checked name={t('mapGeofences.baseLayers.base1')}>
            <TileLayer
              attribution='&copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ'
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name={t('mapGeofences.baseLayers.base2')}>
            {/* Capa de topografía */}
            <TileLayer
              attribution='Tiles &copy; Esri &mdash; Esri, USGS, NOAA'
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name={t('mapGeofences.baseLayers.base3')}>
            <LayerGroup>
              {/* Capa de imágenes satelitales */}
              <TileLayer
                // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                url="https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                attribution='&copy; <a href="https://www.esri.com/">Esri</a> &mdash; Source: Esri, Maxar, Earthstar Geographics'
                />
                {/* Capa de calles */}
                <TileLayer
                  url="https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}"
                  attribution='&copy; <a href="https://www.esri.com/">Esri</a> — Roads & Transportation'
                />
            </LayerGroup>
          </LayersControl.BaseLayer>
        </LayersControl>
      </MapContainer>
    )
  } else {
    return (
      <MapContainer
        className="divMaps"
        center={config.map.center}
        zoom={config.map.zoom_general}
        scrollWheelZoom={false}
      >
        <LayersControl position="topright">
          <LayersControl.BaseLayer checked name={t('mapGeofences.baseLayers.base1')}>
            <TileLayer
              attribution='&copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ'
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name={t('mapGeofences.baseLayers.base2')}>
            {/* Capa de topografía */}
            <TileLayer
              attribution='Tiles &copy; Esri &mdash; Esri, USGS, NOAA'
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name={t('mapGeofences.baseLayers.base3')}>
            <LayerGroup>
              {/* Capa de imágenes satelitales */}
              <TileLayer
                // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                url="https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                attribution='&copy; <a href="https://www.esri.com/">Esri</a> &mdash; Source: Esri, Maxar, Earthstar Geographics'
                />
                {/* Capa de calles */}
                <TileLayer
                  url="https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}"
                  attribution='&copy; <a href="https://www.esri.com/">Esri</a> — Roads & Transportation'
                />
            </LayerGroup>
          </LayersControl.BaseLayer>
        </LayersControl>
      </MapContainer>
    )
  }
}

MapaGeofences.propTypes = {
  type: PropTypes.string,
  unitArea: PropTypes.string,
  setGeofenceData: PropTypes.func,
  info: PropTypes.object
}
